export default __webpack_public_path__ + "static/tech-cisco-6afab7c941a2121f27e5a69ab46601a1.png";